import { authorizedInstance } from "../config/axios"

export const getIllustrationMappingsData = async ({
  page,
  limit,
  sortBy,
  filters,
}) => {
  const query = new URLSearchParams({
    page,
    pageSize: limit,
    ...(sortBy ? { order: sortBy } : {}),
    ...(filters[0]?.value ? { filter: filters[0]?.value } : {}),
  })

  const response = await authorizedInstance.get(`/herniation-mappings?${query}`)
  return response.data
}

export const getIllustrationMappingInfo = async (mappingId) => {
  const response = await authorizedInstance.get(
    `/herniation-mappings/${mappingId}`
  )
  return response.data
}

export const createIllustrationMapping = async (payload) => {
  await authorizedInstance.post("/herniation-mappings", payload)
}

export const updateIllustrationMapping = async (payload) => {
  const mappingId = payload.illustrationMappingId
  delete payload["HerniationMappingId"]

  await authorizedInstance.put(`/herniation-mappings/${mappingId}`, payload)
}

export const deleteIllustrationMapping = async (mappingId) => {
  await authorizedInstance.delete(`herniation-mappings/${mappingId}`)
}
